<gb-ui-page-heading titleText="Accessibility Statement"></gb-ui-page-heading>

<div class="container govuk-width-container">
	<div class="row">
		<div class="col-sm-12 accessibility-statement__body">
			<div [innerHTML]="statement"></div>
		</div>
	</div>

	<div class="row">
		<div class="govuk-grid-column-full">
			<div class="govuk-button-group">
				<button
					type="button"
					class="govuk-button govuk-button--secondary"
					data-module="govuk-button"
					(click)="routerGoBack()"
				>
					{{ 'COMMON.BACK' | translate }}
				</button>
			</div>
		</div>
	</div>
</div>
